import { LinkPresentationProps } from "@insite/mobius/Link";
import { COLORS, ELEMENTS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

export interface ButtonStyles {
    iconPrimaryLightBackground: LinkPresentationProps;
    iconPrimaryDarkBackground: LinkPresentationProps;
    iconSecondryLightBackground: LinkPresentationProps;
    iconSecondryDarrkBackground: LinkPresentationProps;

}

export const buttonStyles: ButtonStyles = {
    iconPrimaryLightBackground: {
        typographyProps: {
            color: `${COLORS.primary.contrast} !important`,
            weight: TYPOGRAPHY.filterButton.weight,
            size: TYPOGRAPHY.filterButton.size,
            css: css`
                font-family: ${TYPOGRAPHY.filterButton.fontFamily};
                font-style: normal;
                line-height: normal;
                color: ${COLORS.primary.contrast};
                letter-spacing: ${TYPOGRAPHY.filterButton.letterSpacing};
            `,
        },
        css: css`
         svg path{
                stroke: ${COLORS.filterIcon.primary.contrast};
            }
        outline-color: transparent !important;
        background-color: ${COLORS.primary.base};
        height: 40px;
        padding: ${ELEMENTS.filterButton.padding};
        border: none;
        &:disabled{
            border: none;
            background-color: ${COLORS.primary.contrast};
        }
        `,
    },
    iconPrimaryDarkBackground: {
        typographyProps: {
            color: `${COLORS.primary.base} !important`,
            weight: TYPOGRAPHY.filterButton.weight,
            size: TYPOGRAPHY.filterButton.size,
            css: css`
                        font-family: ${TYPOGRAPHY.fontFamily.base};
                        font-style: normal;
                        line-height: normal;
                        color: ${COLORS.primary.base};
                        letter-spacing: ${TYPOGRAPHY.filterButton.letterSpacing};
                    `,
        },
        css: css`
            svg path{
                stroke: ${COLORS.filterIcon.primary.base};
            }
                outline-color: transparent !important;
                background-color: #FFFFFF;
                height: 40px;
                padding: ${ELEMENTS.filterButton.padding};
                border: none;
                &:disabled{
                    border: none;
                    background-color: #545454;
                }
                `,
    },
    iconSecondryLightBackground: {
        typographyProps: {
            color: `${COLORS.primary.base} !important`,
            weight: `${TYPOGRAPHY.productDetails.addToCartButton.fontWeight}`,
            size: TYPOGRAPHY.filterButton.size,
            css: css`
                font-family: ${TYPOGRAPHY.filterButton.fontFamily};
                font-style: normal;
                line-height: normal;
                color: ${COLORS.primary.base};
                letter-spacing: ${TYPOGRAPHY.filterButton.letterSpacing};
            `,
        },
        css: css`
         svg path{
                stroke: ${COLORS.filterIcon.primary.base};
            }
        outline-color: transparent !important;
        height: 40px;
        padding: ${ELEMENTS.filterButton.padding};
        border: ${ELEMENTS.filterButton.border};
        &:disabled{
            border: 2px solid #F3F3F3;
            color: #F3F3F3;
        }
        `,
    },
    iconSecondryDarrkBackground: {
        typographyProps: {
            color: "#fff !important",
            weight: TYPOGRAPHY.filterButton.weight,
            size: TYPOGRAPHY.filterButton.size,
            css: css`
                font-family: ${TYPOGRAPHY.filterButton.fontFamily};
                font-style: normal;
                line-height: normal;
                color: #fff;
                letter-spacing: ${TYPOGRAPHY.filterButton.letterSpacing};
            `,
        },
        css: css`
         svg path{
                stroke: #fff;
            }
        outline-color: transparent !important;
        height: 40px;
        padding: ${ELEMENTS.filterButton.padding};
        border: 2px solid #fff;
        &:disabled{
            border: 2px solid #545454;
            color: #545454;
        }
        `,
    },

};